// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2nblZ","calendarButtons":"ClockData_calendarButtons__RdmXR"};